var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cl-checkbox"},_vm._l((_vm.options),function(o,i){return _c('div',{key:i,staticClass:"cl-checkbox-item",class:{checked: _vm.val.indexOf(o) >= 0},on:{"click":function($event){return _vm.handleClick(o)}}},[_c('div',{staticClass:"cl-checkbox-input"}),_c('div',{staticClass:"cl-checkbox-title"},[_vm._v(_vm._s(o))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }